import { useEffect, useState } from "react";
import { BasicPage } from "../../../../theme/Component/BasicPage";
import { BasicTable, MASK_DATE, MASK_MONEY, MASK_NUMBER } from "../../../../theme/Component/BasicTable";
import { Modal } from "../../../../theme/Component/Modal";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { _ActaComite, _single } from "../../../../../core/services/dataBean/EntityCatalog";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { ActaComiteItem } from "./ActaComiteItems/ActaComiteItems";
import { Alert } from "../../../../theme/Component/Alert";
import { ActaComiteBank } from "./ActaComiteBank";
import useModal, { MODAL_LG, MODAL_md, MODAL_SM, MODAL_XL } from "../../../../theme/Component/hooks/useModal";
import { DropDown } from "../../../../theme/Component/DropDown";
import AutoChart from "../../../../../core/graph/AutoChart";
import { InputDate } from "../../../../theme/Input/InputDate";
import { YearSelector } from "../../../../../core/shared/inputs/YearSelector";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import usePaginator from "../../../../theme/Component/usePaginator";
import { VisorAnyDocument } from "../../../../documents/VisorAnyDocument";
import { EncuestaActa } from "./EncuestaActa";

interface formProps {
    Year: number
}

export const ActaComiteEncuesta = () => {

    const { instance, setBean, bean, lista, setLista } = useDataBean(_ActaComite);

    const [modal, setModal] = useState<any>({ view: false, btnClose: true, btnSubmit: true, format: 'modal-xl', });
    const [modalActa, setModalActa] = useState<any>({ view: false, btnClose: true, btnSubmit: true, format: 'modal-xl', });
    const [modalBancos, setModalBancos] = useState<any>({ view: false, btnClose: true, btnSubmit: true, format: 'modal-xl', });
    const modalContabilizar = useModal("Contabilizar", MODAL_md);
    const modalRegistrarCreditos = useModal("Registrar Creditos", MODAL_md);
    const modalGraph = useModal("Grafica", MODAL_XL);
    const paginador = usePaginator();

    const [uriLink, setUrlLink] = useState<string>('');
    const [fechaDesembolso, setFechaDesembolso] = useState<any>(_single.getCurrenDate());
    const [form, setForm] = useState<Partial<formProps>>({});
    const modalEncuesta = useModal("Encuesta",MODAL_md);

    useEffect(() => {
        getLista();
    }, [paginador.page])

    const getLista = () => {
        const Props: any = {}

        if (form.Year) Props.Since = form.Year;

        instance.getActaComiteResumen(paginador.page, 15, Props, null, null).then(
            (resp: any) => {
                paginador.setPages(resp.NumberOfPages);
                paginador.setRecords(resp.NumberOfPages * 15);
                setLista(resp.List)
            }
        ).catch(
            errr => { toast.error(errr) }
        )
    }
    const registrarCreditos = () => {
        console.log(fechaDesembolso);

    }

    const head = [
        { title: 'ID', property: 'IDActaComite', visible: false, mask: MASK_NUMBER },
        { title: 'No. Comite', property: 'ComiteNumber', visible: true },
        { title: 'Fecha de Aprobación', property: 'ApprovedDate', visible: true, mask: MASK_DATE },
        { title: 'Total Solicitado', property: 'totalCreditos', visible: true, mask: MASK_MONEY },
        { title: 'Total Deducciones', property: 'totalDeduccionesCapital', visible: true, mask: MASK_MONEY },
        { title: 'Total Interes', property: 'totalDeduccionesIntereses', visible: true, mask: MASK_MONEY },
        { title: 'Total Desembolso', property: 'totalDesembolso', visible: true, mask: MASK_MONEY },
        { title: 'Estado', property: 'StateName', visible: true },
        { title: 'No. Proceso', property: 'IDProcess', visible: true, mask: MASK_NUMBER },
        { title: 'Fecha Proceso', property: 'ProcessDate', visible: true },
        { title: 'Estado Proceso', property: 'ProcessStateName', visible: true },

    ]
    const getActaComite = () => {
        instance.getActaComiteRender(bean.IDActaComite).then(
            (resp: any) => {
                if (resp.FileName) {

                    setUrlLink("/quickdataerp/temp/docs/" + resp.FileName);
                }
                else {
                    setUrlLink(resp.FileName);

                }
            }
        )
    }
    const contabilizar = () => {
        instance.contabilizarActaCredito(bean.IDActaComite, 1, _single.getCurrenDate(), _single.getAccountID()).then(
            (resp: any) => {
                getLista();
                toast.success("Contabilizacion Completa");
                modalContabilizar.close();
            }
        )
    }

    const listaBotones = () => {
        const botones = [
            // { titulo: 'Ver Acta', icono: 'ri-file-add-line', visible: true, evento: () => { getActaComite(); setModalActa({ ...modalActa, view: true, name: "Ver Acta" }) } },
            // { titulo: 'Archivo Bancos', icono: 'ri-file-add-line', visible: true, evento: () => { setModalBancos({ ...modalBancos, view: true, name: "Ver Bancos" }) } },
            { titulo: 'Ver Afiliados Acta', icono: 'ri-file-add-line', visible: true, evento: () => { setModal({ ...modal, view: true, name: "Items del acta del comite" }) } },
            { titulo: 'Lanzar Encuestas', icono: ' ri-file-chart-line', visible: true, evento: () => { modalEncuesta.open() } },
            // { titulo: 'Contabilizar Acta', icono: 'ri-file-add-line', visible: [0, 1, 4, 3].includes(bean.StateProcess) || !bean.ProcessStateName, evento: () => { modalContabilizar.open() } },
            // { titulo: 'Registrar Creditos', icono: 'ri-file-add-line', visible: bean.StateProcess === 2, evento: () => { modalRegistrarCreditos.open(); setFechaDesembolso(bean.DesertDate) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }
    const actionsDropDown = [
        { id: 1, name: 'Reporte Gráfico', permiso: null, activo: true },
    ];
    const buttons = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    <DropDown lista={actionsDropDown} eventClick={(e) => {
                        if (e.id == 1) {
                            modalGraph.open();
                        }
                    }}></DropDown>
                </div>
            </div>
        )
    }

    return (
        <BasicPage titulo="Actas de Crédito">
            <div className="row">
                <div className="col-md-4">
                    <YearSelector value={form.Year} tittle="Vigencia" onChange={(e) => { setForm({ ...form, Year: e ?? null }) }} />
                </div>
                <div className="col-md-3">
                    <BasicButton useMargin eventClick={() => { getLista() }} icon="ri-search-line" children={`Buscar`} />
                </div>
                <div className="col-md-12">
                    <BasicTable
                        head={head}
                        body={lista}
                        rowSet={setBean}
                        listButtons={listaBotones()}
                        // headButtons={buttons()}
                        records={paginador}
                    />

                    <Modal modal={modalEncuesta.modal} updateModal={modalEncuesta.setModal}>
                        <div className="row">
                            <div className="col-md-12">
                                <EncuestaActa idActa={bean.IDActa}/>
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modal} updateModal={setModal}>
                        <div className="row">
                            <div className="col-md-12">
                                <ActaComiteItem idActaComite={bean.IDActaComite} />
                            </div>
                        </div>
                    </Modal>

                    <Modal modal={modalActa} updateModal={setModalActa}>
                        <div className="row">
                            {uriLink != '' ?
                                <VisorAnyDocument url={window.location.protocol + "//" + window.location.hostname + (window.location.port ? ":" + window.location.port : "") + uriLink} type="pdf" />
                                // <Alert clase="primary">
                                //     <p>
                                //         <strong>Acta de crédito </strong>
                                //         <a className="link cursor" href={uriLink} target="_blank">Descargar</a>
                                //     </p>
                                // </Alert>
                                :
                                <Alert clase="warning">
                                    <p>No se encontro ningun archivo</p>
                                </Alert>
                            }
                        </div>
                    </Modal>

                    <Modal modal={modalBancos} updateModal={setModalBancos}>
                        <div className="row">
                            <ActaComiteBank IDActaComite={bean.IDActaComite} />
                        </div>
                    </Modal>

                    <Modal modal={modalContabilizar.modal} updateModal={modalContabilizar.setModal} eventModal={contabilizar} onSubmitLabel="Contabilizar">
                        <div className="row">
                            <div className="col">
                                <h6>Contabilizar Acta de Crédito ?</h6>
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalGraph.modal} updateModal={modalGraph.setModal}>
                        <AutoChart data={lista} head={head} useIndexAsXLabel={true}
                            xOptions={['ComiteNumber', 'ProcessStateName']}
                            yOptions={['totalCreditos', 'totalDeduccionesCapital', 'totalDeduccionesIntereses', 'totalDesembolso']} />

                    </Modal>
                    <Modal modal={modalRegistrarCreditos.modal} updateModal={modalRegistrarCreditos.setModal} eventModal={registrarCreditos}>
                        <div className="row">
                            <div className="col-md-6">
                                <InputDate name="aprobacion" value={bean.DesertDate} label="Fecha Aprobación" _disable={true} setDate={(e) => { setFechaDesembolso(e) }} />
                            </div>
                            <div className="col-md-6">
                                <InputDate name="Desembolso" value={fechaDesembolso} label="Fecha Desembolso" setDate={(e) => { setFechaDesembolso(e) }} />
                            </div>
                            <div className="col-md-12 p-2">
                                <strong>Nota:</strong> Para creditos con primera cuota en el siguiente mes usar fecha desembolso ultimo dia del mes de aprobación
                            </div>
                        </div>
                    </Modal>
                </div >
            </div >
        </BasicPage >
    )
}